export const ALLOWED_SELLER_TYPE_KEYS: readonly string[] = [
  'SELLERTYPE_DEALERSHIP',
  'SELLERTYPE_PRIVATE_SELLER',
];
